"use client";
import { Video } from "../../media/video.js";
import { MinimalLiveVideoSkin } from "./minimal-skin.js";
import { LiveVideoPlayer, usePlayer } from "./player.js";
import { LiveVideoSkin } from "./skin.js";
import { liveVideoFeatures } from "@videojs/core/dom";
//#region src/presets/live-video/index.ts
/**
* Live video player preset — `video` minus playback rate, quality selection, and audio-track selection, plus the live
* feature, with a skin that swaps the time slider and time displays for a Live button.
*/
//#endregion
export { LiveVideoPlayer, LiveVideoSkin, MinimalLiveVideoSkin, Video, liveVideoFeatures, usePlayer };

//# sourceMappingURL=index.js.map